// extracted by mini-css-extract-plugin
module.exports = {"trigger":"ContactsToggleLabel_trigger_3OC0u","chevron":"ContactsToggleLabel_chevron_XhvRu"};